const PATH = '/checkout';

export const SHIPPING_PATH = 0;
const DATE_PATH = 1;
export const PAYMENT_PATH = 2;
export const CONGRATS_PATH = 3;

let paths = {
  [SHIPPING_PATH]: `${PATH}/shipping/`,
  [DATE_PATH]: `${PATH}/date/`,
  [PAYMENT_PATH]: `${PATH}/payment/`,
  [CONGRATS_PATH]: `${PATH}/congrats`,
};

export const PATHS = paths;

let addressValidationErrors = {
  UnsupportedAddress:
    'Unfortunately the address you entered is outside our delivery zone. Read more about our supported areas <a href="https://support.hungryroot.com/hc/en-us/articles/115006359108-Where-does-Hungryroot-deliver-#:~:text=Hungryroot%20delivers%20to%20most%20zip,our%20service%20for%20your%20area">here</a>. Hope to see you soon!',
  InvalidAddress:
    'Please double check that all the required fields have been filled with correct information.<br/>',
};

export const AVE = addressValidationErrors;
